// useSessionGuard.js
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import helpers from './helpers';

export default function useSessionGuard() {
  useEffect(() => {
    const interval = setInterval(() => {
      const token = helpers.getToken();
      const isAuthenticated = helpers.isAuthenticated();
      const currentPath = window.location.pathname;

      const isAllowedPath =
        currentPath === '/login' ||
        currentPath === '/' ||
        /^\/product-units\/qr\/[^/]+$/.test(currentPath); // matches dynamic-id

      if (!isAllowedPath && (!isAuthenticated || token === 'undefined')) {
        clearInterval(interval);
        Swal.fire({
          text: 'Your session has changed or expired. Please log in again to continue using the app.',
          showConfirmButton: true,
          confirmButtonText: 'Log In',
          icon: 'error',
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/login';
          }
        });
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);
}